import Coupon from './coupon';

export default Coupon;
